import DateText from 'components/date-text';
import styles from './style.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import { buildClassName } from 'utils/build-class-name';

interface BlogCardProps {
  title: string;
  link: string;
  topLabel: string;
  imageSrc?: string;
  date: string;
  excerpt: string;
  isFeaturedCard?: boolean;
  hideExcerpt?: boolean;
}

export default function BlogCard({ title, link, topLabel, imageSrc, date, excerpt, isFeaturedCard = false, hideExcerpt = false }: BlogCardProps) {
  return (
    <article className={buildClassName(styles.component, isFeaturedCard && styles['featured-card'])}>
      <Link href={link} className={styles['image-wrapper']}>
        <Image
          src={imageSrc || '/next/assets/images/agent-search/no-agent-photo.png'}
          alt={''}
          width={0}
          height={0}
          sizes="100=vw"
        />
      </Link>
      <div className={styles['text-section']}>
        <div className={styles['top-label']}>{topLabel}</div>
        <Link href={link}><h3 className={styles.title}>{title}</h3></Link>
        {!hideExcerpt && <div className={styles.excerpt} dangerouslySetInnerHTML={{ __html: excerpt }} />}
        <DateText date={date} template="MMMM D, YYYY" render={formattedDate => <p className={styles.date}>{formattedDate}</p>} />
      </div>
    </article>
  );
}